"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tenantSettingLogListesiSchema = exports.tenantSettingLogSatiriSchema = exports.ptwKontrolOzetiSchema = exports.ptwIzinKapaliKontrolleriSchema = exports.ptwKontrolMatrisSatiriSchema = exports.ptwKontrolMatrisYazmaSchema = exports.PTW_UYGUNLUK_KURAL_ETIKETI = exports.PTW_UYGUNLUK_DURUM_ETIKETI = exports.ptwUygunlukDurumuSchema = exports.PTW_UYGUNLUK_DURUMLARI = exports.PTW_KURAL_YAPILANDIRMA_YERI_ETIKETI = exports.PTW_KURAL_YAPILANDIRMA_YERI = exports.PTW_KURAL_YAPILANDIRMA_YERLERI = exports.PTW_DAYANAK_DOGRULANACAK = exports.PTW_KAPI_DAYANAGI = exports.PTW_FIZIKSEL_TEHLIKE_KURALLARI = exports.PTW_KAPI_KURALLARI = exports.PTW_KURAL_SINIFI = exports.PTW_KURAL_SINIFLARI = exports.PtwKuralKoduBilinmiyorError = exports.PTW_KURAL_KONTROL_TIPI = exports.PTW_KONTROL_TIPI_AILESI = exports.PTW_KONTROL_MATRISI_ANAHTARI = exports.PTW_KONTROL_VARSAYILAN_DEGERI = exports.ptwKontrolHucreKonumuSchema = exports.PTW_KONTROL_HUCRE_KONUMLARI = exports.ptwKontrolDegeriSchema = exports.PTW_KONTROL_DEGERLERI = exports.ayarKapsamiSchema = exports.AYAR_KAPSAMLARI = exports.PTW_KONTROL_AILESI_BASLIGI = exports.PTW_KONTROL_AILESI_ETIKETI = exports.ptwKontrolAilesiSchema = exports.PTW_KONTROL_AILELERI = void 0;
exports.ptwKuralKontrolTipi = ptwKuralKontrolTipi;
exports.ptwKuralAilesi = ptwKuralAilesi;
exports.kontrolMatrisiHucreleri = kontrolMatrisiHucreleri;
exports.kontrolMatrisiCoz = kontrolMatrisiCoz;
exports.izinKontrolAileleri = izinKontrolAileleri;
exports.izinKontrolAileleriCoz = izinKontrolAileleriCoz;
exports.kapaliKontrolAileleri = kapaliKontrolAileleri;
exports.ptwKuralAilesiAcikMi = ptwKuralAilesiAcikMi;
exports.kapaliKontrollerMetni = kapaliKontrollerMetni;
exports.ptwKapiDayanagi = ptwKapiDayanagi;
exports.ptwKalemleriAileyeGore = ptwKalemleriAileyeGore;
exports.ptwUygunlukBosMetni = ptwUygunlukBosMetni;
exports.ptwUygunlukDurumu = ptwUygunlukDurumu;
const zod_1 = require("zod");
const shared_types_1 = require("@isg/shared-types");
/**
 * PTW KONTROL MATRİSİ + ÜÇ SINIF (dilim 2 — 15.09.2026; Kapsam §16.7.5 ✏️ ·
 * §14 K-73a…g).
 *
 * *"Sistem olguyu söyler; bildiği ve yasak olanı imzalamaz; gerisi sahanın
 * kararıdır."*
 *
 * Uygunluk motoru TEK kalır (anlık = canlı — §2.5); bu dosya motorun kalem
 * ÜRETİMİNİ koşullayan üç şeyi taşır ve üç katmanın da işine yaradığı için
 * evi validation'dır (motor süzer · ekran hücreyi çizer · pano sayar):
 *
 *  1. **AİLE EŞLEMESİ** — kural kodu → kontrol tipi → aile. Tek harita; kalem
 *     başına elle yazılmaz, eşlenemeyen kod FAIL-LOUD.
 *  2. **ÇÖZÜMLEYİCİ** — holding varsayılanı + işyeri istisnası; satır yoksa
 *     holdingde KAPALI (K-73c), işyerinde DEVRAL (K-73b). Saf fonksiyon: DB
 *     çözümleyicisi (`@isg/db resolveKontrolMatrisi`) satırları okuyup BUNU
 *     çağırır — motor, ekran ve pano aynı cevabı verir.
 *  3. **SINIF** — kapı · kural · uyarı + kapı dayanağı + kuralın yapılandırma
 *     yeri. Ekran kırmızı kalemin rozetini buradan okur; ikinci harita yazmaz.
 *
 * ⚠️ Bu dosya `./ptw`den YALNIZ TİP alır — `ptw.ts` buradan değer
 * (`PTW_UYGUNLUK_DURUMLARI`) okuduğu için çalışma zamanı döngüsü doğmasın.
 */
// ── Aileler ──────────────────────────────────────────────────────────────────
/** Dört aile (K-73a). Sıra = ekran kolonu sırası = iz satırı sırası. */
exports.PTW_KONTROL_AILELERI = ['egitim', 'saglik', 'ekipman', 'yuklenici'];
exports.ptwKontrolAilesiSchema = zod_1.z.enum(exports.PTW_KONTROL_AILELERI);
/** İz satırı ve pano cümlesi — küçük harf ("Kapalı kontroller: eğitim · sağlık"). */
exports.PTW_KONTROL_AILESI_ETIKETI = {
    egitim: 'eğitim',
    saglik: 'sağlık',
    ekipman: 'ekipman',
    yuklenici: 'yüklenici',
};
/** Matris kolon başlığı ve pano satırı başı — büyük harfle. */
exports.PTW_KONTROL_AILESI_BASLIGI = {
    egitim: 'Eğitim',
    saglik: 'Sağlık',
    ekipman: 'Ekipman',
    yuklenici: 'Yüklenici',
};
/** Holding varsayılanı (satırı `workplace_id` NULL) · işyeri istisnası. */
exports.AYAR_KAPSAMLARI = ['holding', 'isyeri'];
exports.ayarKapsamiSchema = zod_1.z.enum(exports.AYAR_KAPSAMLARI);
exports.PTW_KONTROL_DEGERLERI = ['acik', 'kapali'];
exports.ptwKontrolDegeriSchema = zod_1.z.enum(exports.PTW_KONTROL_DEGERLERI);
/**
 * Hücre ÜÇ KONUMLUDUR (K-73b). *devral* bir DEĞER değil satırın YOKLUĞUDUR —
 * yalnız işyeri hücresinde anlamlıdır; holding hücresinde yoktur (422).
 * ⚠️ İki konumlu düğmeye indirgenmez: holding sonradan açınca işyerinin
 * "kapalı sandığı" hücre açılmamalıdır — "kapalı" ile "devral" ayrı kalır.
 */
exports.PTW_KONTROL_HUCRE_KONUMLARI = ['devral', 'acik', 'kapali'];
exports.ptwKontrolHucreKonumuSchema = zod_1.z.enum(exports.PTW_KONTROL_HUCRE_KONUMLARI);
/** Satır yoksa holding hücresi (K-73c — varsayılan kapalı; seed satır yazmaz). */
exports.PTW_KONTROL_VARSAYILAN_DEGERI = 'kapali';
/** Ayar defterinde (`tenant_setting_log.anahtar`) matris hücresinin anahtarı. */
exports.PTW_KONTROL_MATRISI_ANAHTARI = 'ptw_kontrol_matrisi';
// ── 1. Aile eşlemesi ─────────────────────────────────────────────────────────
/**
 * KONTROL TİPİ → AİLE. `participant` (tür→zorunlu görev) aileye GİRMEZ:
 * izin bileşimi kuralıdır, kendi matrisi var (§19/14) — bugünkü davranış.
 */
exports.PTW_KONTROL_TIPI_AILESI = {
    training: 'egitim',
    health: 'saglik',
    equipment: 'ekipman',
    contractor: 'yuklenici',
    participant: null,
};
/**
 * KURAL KODU → KONTROL TİPİ — kalemin kontrol tipinin TEK kaynağı. Motor
 * (`kalemYap`) kontrol tipini çağrı yerinden almaz, buradan okur; yoksa aynı
 * kalemin tipi ile ailesi iki yerden gelir ve bir gün ayrışır.
 * `Record` tam eşitlik ister: yeni kural kodu bu satırı yazmadan derlenmez.
 */
exports.PTW_KURAL_KONTROL_TIPI = {
    yetkinlik_yok: 'training',
    temel_isg_egitimi_yok: 'training',
    yetkinlik_suresi_doldu: 'training',
    yetkinlik_henuz_gecerli_degil: 'training',
    yetkinlik_istihdam_oncesi: 'training',
    izin_veren_egitimi: 'training',
    bilgi_yenileme_gerekli: 'training',
    ilave_egitim_gerekli: 'training',
    ekipman_kontrol_tarihi_bilinmiyor: 'equipment',
    ekipman_marji: 'equipment',
    ekipman_pasif: 'equipment',
    saha_giris_evraki: 'contractor',
    zorunlu_gorev_eksik: 'participant',
    saglik_kanaati_yok: 'health',
    saglik_kanaati_suresi_doldu: 'health',
    saglik_uygun_degil: 'health',
    saglik_kisiti: 'health',
    saglik_farkli_isyeri: 'health',
};
/** Tanınmayan kural kodu — kayıttan (DB metni) gelen bozuk değer dahil. */
class PtwKuralKoduBilinmiyorError extends Error {
    kural;
    constructor(kural) {
        super(`Uygunluk kural kodu tanınmıyor: ${kural}`);
        this.kural = kural;
        this.name = 'PtwKuralKoduBilinmiyorError';
    }
}
exports.PtwKuralKoduBilinmiyorError = PtwKuralKoduBilinmiyorError;
/** Kural kodunun kontrol tipi — tanınmayan kod FAIL-LOUD (aileye sessizce düşmez). */
function ptwKuralKontrolTipi(kural) {
    if (!Object.hasOwn(exports.PTW_KURAL_KONTROL_TIPI, kural))
        throw new PtwKuralKoduBilinmiyorError(kural);
    return exports.PTW_KURAL_KONTROL_TIPI[kural];
}
/** Kural kodunun ailesi; `null` = matris dışı (zorunlu görev). */
function ptwKuralAilesi(kural) {
    return exports.PTW_KONTROL_TIPI_AILESI[ptwKuralKontrolTipi(kural)];
}
/**
 * ÇÖZÜMLEYİCİNİN ÇEKİRDEĞİ — tek (işyeri, izin türü) için dört hücre.
 * `workplaceId = null` holding görünümüdür (işyeri katmanı okunmaz).
 */
function kontrolMatrisiHucreleri(satirlar, workplaceId, izinTuruRefId) {
    const hucre = (aile) => {
        const holding = satirlar.find((s) => s.workplaceId === null && s.izinTuruRefId === izinTuruRefId && s.aile === aile)?.deger ?? exports.PTW_KONTROL_VARSAYILAN_DEGERI;
        const isyeri = workplaceId === null
            ? null
            : (satirlar.find((s) => s.workplaceId === workplaceId && s.izinTuruRefId === izinTuruRefId && s.aile === aile)?.deger ?? null);
        return { holding, isyeri, gecerli: isyeri ?? holding };
    };
    return {
        egitim: hucre('egitim'),
        saglik: hucre('saglik'),
        ekipman: hucre('ekipman'),
        yuklenici: hucre('yuklenici'),
    };
}
/** `resolveKontrolMatrisi(işyeri, izin türü)` — geçerli değerler (K-73b). */
function kontrolMatrisiCoz(satirlar, workplaceId, izinTuruRefId) {
    const hucreler = kontrolMatrisiHucreleri(satirlar, workplaceId, izinTuruRefId);
    return {
        egitim: hucreler.egitim.gecerli,
        saglik: hucreler.saglik.gecerli,
        ekipman: hucreler.ekipman.gecerli,
        yuklenici: hucreler.yuklenici.gecerli,
    };
}
/**
 * ÇOK TÜRLÜ İZİN — aile türlerden HERHANGİ BİRİNDE açıksa koşar (sıkı olan
 * kazanır; emsal: aynı kişi iki yüklenicideyse hepsi geçerli olmalı — tur 10 /
 * K2.2). Türsüz izinde (liste boş) aileler KAPALIDIR: çözümlenecek hücre yok.
 */
function izinKontrolAileleri(matrisler) {
    const acik = (aile) => matrisler.some((m) => m[aile] === 'acik') ? 'acik' : 'kapali';
    return {
        egitim: acik('egitim'),
        saglik: acik('saglik'),
        ekipman: acik('ekipman'),
        yuklenici: acik('yuklenici'),
    };
}
/**
 * BİR İZNİN AİLELERİ — motorun ve iz dondurmasının TEK girişi.
 *
 * Türler tek tek çözülür ve `izinKontrolAileleri` ile birleşir. ✏️ Türetme:
 * **TÜRSÜZ İZİN** (tür seçimi API'de isteğe bağlı — `izinTuruRefIds`
 * optional) matrisin **HERHANGİ BİR türünde** açık olan aileyi taşır: tür
 * seçmemek kontrolden kaçış yolu olmamalıdır (sıkı olan kazanır). Aday türler
 * satırlardan okunur; satırı olmayan tür zaten KAPALIDIR (K-73c), bu yüzden
 * eksik aday yoktur.
 */
function izinKontrolAileleriCoz(satirlar, workplaceId, izinTuruRefIds) {
    const turler = izinTuruRefIds.length > 0
        ? izinTuruRefIds
        : [...new Set(satirlar.map((satir) => satir.izinTuruRefId))];
    return izinKontrolAileleri(turler.map((izinTuruRefId) => kontrolMatrisiCoz(satirlar, workplaceId, izinTuruRefId)));
}
/** Kapalı aileler — iz satırının içeriği, sabit sırayla. */
function kapaliKontrolAileleri(matris) {
    return exports.PTW_KONTROL_AILELERI.filter((aile) => matris[aile] === 'kapali');
}
/**
 * MOTORUN SÜZGECİ — kalem üretilir mi. Matris dışı kod (`participant`) her
 * zaman üretilir; tanınmayan kod FAIL-LOUD (`ptwKuralAilesi`).
 */
function ptwKuralAilesiAcikMi(matris, kural) {
    const aile = ptwKuralAilesi(kural);
    return aile === null || matris[aile] === 'acik';
}
/**
 * İZ SATIRI (K-73f) — detay ve PDF'in AYNI cümlesi. Kapalı aile yoksa `null`
 * (satır basılmaz); açık aileler yazılmaz, kalem kalem yazılmaz.
 */
function kapaliKontrollerMetni(aileler) {
    if (aileler.length === 0)
        return null;
    const sirali = exports.PTW_KONTROL_AILELERI.filter((aile) => aileler.includes(aile));
    return `Kapalı kontroller: ${sirali.map((aile) => exports.PTW_KONTROL_AILESI_ETIKETI[aile]).join(' · ')}`;
}
// ── 3. Sınıf ─────────────────────────────────────────────────────────────────
/**
 * ÜÇ SINIF (Kapsam §16.7.5 ✏️; ölçüt Yönerge §4): (a) kanun açıkça yasaklıyor
 * mu · (b) sistem olguyu kesin biliyor mu, yoksa bilmediği için mi "yok"
 * diyor · (c) yanlışın bedeli fiziksel mi. Üçü evet → KAPI; (a) evet (b)
 * hayır → KURAL. Bu yüzden `saglik_kanaati_yok` KURALDIR (sistem hekimin
 * sustuğunu değil kaydın girilmediğini bilir), `saglik_uygun_degil` KAPIDIR.
 */
exports.PTW_KURAL_SINIFLARI = ['kapi', 'kural', 'uyari'];
exports.PTW_KURAL_SINIFI = {
    saglik_uygun_degil: 'kapi',
    saglik_kisiti: 'kapi',
    saglik_kanaati_suresi_doldu: 'kapi',
    ekipman_kontrol_tarihi_bilinmiyor: 'kapi',
    ekipman_marji: 'kapi',
    saha_giris_evraki: 'kapi',
    bilgi_yenileme_gerekli: 'kapi',
    ilave_egitim_gerekli: 'kapi',
    temel_isg_egitimi_yok: 'kural',
    yetkinlik_istihdam_oncesi: 'kural',
    yetkinlik_yok: 'kural',
    yetkinlik_suresi_doldu: 'kural',
    yetkinlik_henuz_gecerli_degil: 'kural',
    izin_veren_egitimi: 'kural',
    saglik_kanaati_yok: 'kural',
    zorunlu_gorev_eksik: 'kural',
    saglik_farkli_isyeri: 'uyari',
    ekipman_pasif: 'uyari',
};
/** Kapı kalemlerinin sayısı — pano "kapı kontrolleri N" satırı buradan. */
exports.PTW_KAPI_KURALLARI = Object.keys(exports.PTW_KURAL_SINIFI).filter((kural) => exports.PTW_KURAL_SINIFI[kural] === 'kapi');
/**
 * FİZİKSEL TEHLİKE AYRI İŞARETİ (K-73e): kırılınca fiziken tehlikeli olan
 * kapı — kontrolün iznin ortasında dolmasını engeller (§2.4). Marj günü
 * müşteriye açılmaz.
 */
exports.PTW_FIZIKSEL_TEHLIKE_KURALLARI = ['ekipman_marji'];
const DAYANAK_ISG_KANUNU = '6331 sayılı İş Sağlığı ve Güvenliği Kanunu';
const DAYANAK_IS_EKIPMANLARI = 'İş Ekipmanlarının Kullanımında Sağlık ve Güvenlik Şartları Yönetmeliği';
/**
 * KAPI DAYANAĞI — TAM AD, madde numarası YOK (madde 236: yüzeyde madde atfı
 * durmaz — §2.40 belge referansı kolu). `null` = **doğrulanacak**: dayanak
 * ölçülmeden yüzeye yazılmaz (envanter §1 — saha girişi evrakı ve T7).
 */
exports.PTW_KAPI_DAYANAGI = {
    saglik_uygun_degil: DAYANAK_ISG_KANUNU,
    saglik_kisiti: DAYANAK_ISG_KANUNU,
    saglik_kanaati_suresi_doldu: DAYANAK_ISG_KANUNU,
    ekipman_kontrol_tarihi_bilinmiyor: DAYANAK_IS_EKIPMANLARI,
    ekipman_marji: DAYANAK_IS_EKIPMANLARI,
    saha_giris_evraki: null,
    bilgi_yenileme_gerekli: null,
    ilave_egitim_gerekli: null,
};
exports.PTW_DAYANAK_DOGRULANACAK = 'Dayanak doğrulanacak';
/** Kapı kaleminin dayanak cümlesi; kapı değilse `null`. */
function ptwKapiDayanagi(kural) {
    if (exports.PTW_KURAL_SINIFI[kural] !== 'kapi')
        return null;
    return exports.PTW_KAPI_DAYANAGI[kural] ?? exports.PTW_DAYANAK_DOGRULANACAK;
}
/** KURAL kaleminin yapılandırıldığı yer — rozet oraya bağ verir. */
exports.PTW_KURAL_YAPILANDIRMA_YERLERI = [
    'kontrol_matrisi',
    'izin_ici_gorevler',
    'tur_matrisi',
];
exports.PTW_KURAL_YAPILANDIRMA_YERI = {
    // `on_kosul` şartının yazan yüzeyi yok (madde 238 — dilim 3); bugün
    // kapatma yolu ailedir.
    temel_isg_egitimi_yok: 'kontrol_matrisi',
    yetkinlik_istihdam_oncesi: 'kontrol_matrisi',
    saglik_kanaati_yok: 'kontrol_matrisi',
    yetkinlik_yok: 'izin_ici_gorevler',
    yetkinlik_suresi_doldu: 'izin_ici_gorevler',
    yetkinlik_henuz_gecerli_degil: 'izin_ici_gorevler',
    izin_veren_egitimi: 'izin_ici_gorevler',
    zorunlu_gorev_eksik: 'tur_matrisi',
};
exports.PTW_KURAL_YAPILANDIRMA_YERI_ETIKETI = {
    kontrol_matrisi: 'Kontrol matrisi',
    izin_ici_gorevler: 'İzin içi görevler',
    tur_matrisi: 'Tür → zorunlu görev matrisi',
};
function ptwKalemleriAileyeGore(kalemler) {
    const siralama = [...exports.PTW_KONTROL_AILELERI, null];
    return siralama
        .map((aile) => {
        const grup = kalemler.filter((k) => ptwKuralAilesi(k.kural) === aile);
        const yerler = [];
        for (const k of grup) {
            const yer = exports.PTW_KURAL_SINIFI[k.kural] === 'kural' ? exports.PTW_KURAL_YAPILANDIRMA_YERI[k.kural] : undefined;
            if (yer && !yerler.includes(yer))
                yerler.push(yer);
        }
        return { aile, kalemler: grup, yapilandirmaYerleri: yerler };
    })
        .filter((g) => g.kalemler.length > 0);
}
// ── Rozet (madde 239) ────────────────────────────────────────────────────────
/**
 * UYGUNLUK DURUMU — boş ≠ uygun (K12 *boş ≠ sıfır*ın kardeşi). Kalem yokken
 * *"değerlendirilmedi"*; yeşil yalnız en az bir kalem geçtiyse. `uygun`
 * bayrağı aynen durur (kapalı aile izni DURDURMAZ — geçiş kapısı onu okur).
 */
exports.PTW_UYGUNLUK_DURUMLARI = ['uygun', 'uygun_degil', 'degerlendirilmedi'];
exports.ptwUygunlukDurumuSchema = zod_1.z.enum(exports.PTW_UYGUNLUK_DURUMLARI);
exports.PTW_UYGUNLUK_DURUM_ETIKETI = {
    uygun: 'Uygun',
    uygun_degil: 'Uygun değil',
    degerlendirilmedi: 'Değerlendirilmedi',
};
/**
 * ✏️ K-96 (bulgu 96 — 16.09.2026): KALEM YOKKEN SÖYLENECEK TEK CÜMLE.
 *
 * Saha ekranı aktif izinde *"katılımcı, ekipman ve izin türü eklendikçe
 * kontrol burada çalışır"* diyordu — üçü de ekliyken. Kalem yokluğunun gerçek
 * sebebi çoğu zaman kontrol matrisidir (aile bu izin türünde kapalı, K-73c
 * varsayılanı); cümle onu ADIYLA söyler. Ekranın kendi metni yok: onay
 * penceresi, detay ve saha ekranı bunu okur.
 */
function ptwUygunlukBosMetni(kapaliAileler) {
    if (kapaliAileler.length === exports.PTW_KONTROL_AILELERI.length) {
        return 'Kontrol edilecek kalem yok — bu izin türünde tüm kontrol aileleri kapalı.';
    }
    if (kapaliAileler.length === 0) {
        return 'Kontrol edilecek kalem yok — bu izne uygulanan bir kontrol şartı tanımlı değil.';
    }
    const sirali = exports.PTW_KONTROL_AILELERI.filter((aile) => kapaliAileler.includes(aile));
    return ('Kontrol edilecek kalem yok — ' +
        `${sirali.map((aile) => exports.PTW_KONTROL_AILESI_BASLIGI[aile]).join(' · ')} kontrolleri bu izin türünde kapalı; ` +
        'açık ailelerde bu izne uygulanan şart yok.');
}
function ptwUygunlukDurumu(kalemler) {
    if (kalemler.length === 0)
        return 'degerlendirilmedi';
    return kalemler.every((kalem) => kalem.uygun) ? 'uygun' : 'uygun_degil';
}
/**
 * KURAL ETİKETİ — tam harita (madde 235: web'deki kısmi harita sağlık ve T7
 * kodlarını taşımıyordu ve rozet iç token'ı basıyordu). `Record` tam eşitlik:
 * yeni kod etiketsiz derlenmez. Web bunu yeniden dışa verir.
 */
exports.PTW_UYGUNLUK_KURAL_ETIKETI = {
    yetkinlik_yok: 'Yetkinlik yok',
    temel_isg_egitimi_yok: 'Temel İSG eğitimi yok',
    yetkinlik_suresi_doldu: 'Yetkinlik süresi doldu',
    yetkinlik_istihdam_oncesi: 'Belge işe girişten önce',
    yetkinlik_henuz_gecerli_degil: 'Belge henüz geçerli değil',
    izin_veren_egitimi: 'İzin veren eğitimi',
    bilgi_yenileme_gerekli: 'Bilgi yenileme eğitimi gerekli',
    ilave_egitim_gerekli: 'İlave eğitim gerekli',
    ekipman_kontrol_tarihi_bilinmiyor: 'Ekipman kontrol tarihi bilinmiyor',
    ekipman_marji: 'Ekipman kontrol marjı',
    ekipman_pasif: 'Ekipman pasife alındı',
    saha_giris_evraki: 'Yüklenici saha girişi',
    zorunlu_gorev_eksik: 'Zorunlu görev eksik',
    saglik_kanaati_yok: 'Sağlık kanaati yok',
    saglik_kanaati_suresi_doldu: 'Sağlık kanaati süresi doldu',
    saglik_uygun_degil: 'Hekim kanaati: uygun değil',
    saglik_kisiti: 'Sağlık kısıtı',
    saglik_farkli_isyeri: 'Kanaat başka işyeri için',
};
// ── Yazma şeması ─────────────────────────────────────────────────────────────
/**
 * `PUT ptw/config/control-matrix` gövdesi — BİR hücre. Holdingde *devral*
 * yoktur ve işyeri taşımaz; işyeri istisnası işyeri ister (şema kuralı →
 * 400; kayıt varlığı kuralı servisin 422'si).
 */
exports.ptwKontrolMatrisYazmaSchema = zod_1.z
    .object({
    kapsam: exports.ayarKapsamiSchema,
    workplaceId: zod_1.z.uuid().nullable().optional(),
    izinTuruRefId: zod_1.z.uuid(),
    aile: exports.ptwKontrolAilesiSchema,
    konum: exports.ptwKontrolHucreKonumuSchema,
})
    .superRefine((girdi, ctx) => {
    if (girdi.kapsam === 'holding') {
        if (girdi.workplaceId) {
            ctx.addIssue({ code: 'custom', message: 'Holding varsayılanı bir işyeri taşımaz' });
        }
        if (girdi.konum === 'devral') {
            ctx.addIssue({
                code: 'custom',
                message: 'Holding varsayılanında "devral" konumu yoktur — açık ya da kapalı seçin',
            });
        }
    }
    else if (!girdi.workplaceId) {
        ctx.addIssue({ code: 'custom', message: 'İşyeri istisnası için işyeri seçilmelidir' });
    }
});
// ── Yüzey sözleşmeleri — ekran · pano · iz · defter ─────────────────────────
/** `GET ptw/config` — matris SATIRLARI; ekran hücreleri `kontrolMatrisiHucreleri`
 *  ile çözer (motorla AYNI saf fonksiyon — ikinci hesap yazılmaz). */
exports.ptwKontrolMatrisSatiriSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid().nullable(),
    izinTuruRefId: zod_1.z.uuid(),
    aile: exports.ptwKontrolAilesiSchema,
    deger: exports.ptwKontrolDegeriSchema,
});
/**
 * İZ SATIRI (K-73f) — izin detayı ve PDF. `donduruldu`: açılış onay turu
 * tamamlandı ve aileler kayda yazıldı; değilse `aileler` CANLI çözümdür.
 * `metin` `kapaliKontrollerMetni`nden (null = satır basılmaz).
 */
exports.ptwIzinKapaliKontrolleriSchema = zod_1.z.object({
    aileler: zod_1.z.array(exports.ptwKontrolAilesiSchema),
    donduruldu: zod_1.z.boolean(),
    metin: zod_1.z.string().nullable(),
});
const sayi = zod_1.z.number().int().nonnegative();
/**
 * MUSLUK PANOSU (bulgu 75 — Kapsam §23/6-7 ✏️). Anahtar eklenmez, OLMAYAN
 * SAYILIR. Aile sayıları holding varsayılanıdır ve TEK çözümleyiciden
 * (`kontrolMatrisiHucreleri`) gelir; gevşeten işyeri = holdingin AÇTIĞI bir
 * hücreyi KAPATAN aktif işyeri.
 */
exports.ptwKontrolOzetiSchema = zod_1.z.object({
    aileler: zod_1.z.array(zod_1.z.object({ aile: exports.ptwKontrolAilesiSchema, kapaliTurSayisi: sayi, turSayisi: sayi })),
    gevseyenIsyeriSayisi: sayi,
    gorevYetkinlikSartiSayisi: sayi,
    onKosulKalemSayisi: sayi,
    zorunluGorevTurSayisi: sayi,
    turSayisi: sayi,
    onayZinciriIsyeriSayisi: sayi,
    aktifIsyeriSayisi: sayi,
    /** ✏️ K-102a/K-102d (17.09.2026): sözlükteki zorunlu işareti düştü — pano paketi sayar. */
    evrakPaketiSayisi: sayi,
    ozelEkliYukleniciSayisi: sayi,
    kapiKontrolSayisi: sayi,
});
/** AYAR DEFTERİ satırı (K-73g) — adlar ve değer metni SUNUCUDA çözülür. */
exports.tenantSettingLogSatiriSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    anahtar: zod_1.z.string().min(1),
    anahtarEtiketi: zod_1.z.string().min(1),
    kapsam: exports.ayarKapsamiSchema,
    isyeriAd: zod_1.z.string().nullable(),
    izinTuruAd: zod_1.z.string().nullable(),
    aile: exports.ptwKontrolAilesiSchema.nullable(),
    eskiMetin: zod_1.z.string(),
    yeniMetin: zod_1.z.string(),
    kimAd: zod_1.z.string().nullable(),
    sapka: zod_1.z.enum(shared_types_1.ROLE_TYPES).nullable(),
    zaman: zod_1.z.iso.datetime(),
});
exports.tenantSettingLogListesiSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.tenantSettingLogSatiriSchema),
    toplam: sayi,
    sayfa: zod_1.z.number().int().min(1),
    sayfaBoyutu: zod_1.z.number().int().min(1),
});
//# sourceMappingURL=ptw-kontrol-matrisi.js.map